import { BaseModel, PhoneNumber } from '@red/data-access';
import { Expose, Type } from 'class-transformer';
import { INoReminder } from '../interfaces/no-reminder.interface';
import { PersonalParticularModel } from './personal-particular.model';
import { UpdatedByModel } from './updated-by.model';

export class NoReminderModel extends BaseModel implements INoReminder {
  @Expose()
  id!: number;

  @Expose()
  agentId!: number;

  @Expose()
  @Type(() => PersonalParticularModel)
  agent!: PersonalParticularModel;

  @Expose()
  isActive!: boolean;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  @Type(() => UpdatedByModel)
  updatedBy?: UpdatedByModel;

  get contactNo(): string | null {
    const mobile = this.agent?.mobile1;
    return mobile ? `+${mobile.countryCode} ${mobile.phoneNumber}` : null;
  }

  get email(): string | undefined {
    return this.agent?.email1;
  }
}
